import React, { useState } from 'react';
import { Modal, Divider, Button, Grid, Image, Message } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import DefaultCategory from '../../drive/Categories/DefaultCategory';
import noImage from '../../../images/common/broken-image.png'
import refImg from '../../../images/svg/noti-content.svg'
import EllipsisTooltip from '../../common/EllipsisTooltip';
import Labels from '../../common/Labels';



const PlaybookInfoModal = ({ playbookInfoModal, closeInfoModal, playbook, submitModal, categoryList, selectedAccount }) => {

    const [selectedCategories, setSelectedCategories] = useState([]);
    const submitInfoModal = () => {
        submitModal(selectedCategories);
    }
    const addDefaultSrc = (ev) => {
        ev.target.src = noImage
    }
    const disableSubmitButton = selectedCategories.length !== 3
    return <Modal
        animated
        open={playbookInfoModal}
        onClose={closeInfoModal}
        size='small'
        className="basicModal"
        closeOnEscape={true}
        closeOnDimmerClick={false}
        closeIcon
    >
        <Modal.Header>Import Playbook</Modal.Header>
        <Divider style={{ margin: "10px 0 0px" }} />
        <Modal.Content scrolling>
            <Form noValidate
                id='importPlaybook'
                onValidSubmit={(data) => submitInfoModal(data)}
                className="formcyForm"
            >

                <Grid>
                    <Grid.Row>
                        <Grid.Column width={6}>
                            <Labels
                                name={playbook.name}
                                text={<Image onError={addDefaultSrc} alt={playbook.name} src={playbook.picture} />}
                            />
                        </Grid.Column>
                        <Grid.Column width={10}>
                            <Labels
                                className="bg-none"
                                name="Description"
                                text={playbook.description ? playbook.description : "No Description Added."}
                                htmlView={true} />
                        </Grid.Column>
                    </Grid.Row>
                    {playbook.references > 0 &&
                        <Message icon >
                            <Image src={refImg} height="12px" style={{ margin: "0 5px 0 0" }} />
                            <Message.Content> {playbook.references} {playbook.references === 1 ? "reference" : "references"}  is attached in Playbook</Message.Content>
                        </Message>}<br /><br />
                </Grid>
                <strong>Assigning knowledge bank from your workspace</strong>
                <DefaultCategory
                    allCategories={categoryList}
                    handleCategorySelection={setSelectedCategories}
                    pageLevel="import"
                    selectedAccount={selectedAccount}
                    dropdownPointing="bottom center" />
            </Form>
        </Modal.Content>

        <Modal.Actions className="actionInFormcy">
            <Button
                className="button-submit float-right"
                id='importPlaybook'
                disabled={disableSubmitButton}
                onClick={submitInfoModal}
            > Import Now </Button>
            <Button
                id='copyCancel'
                className="button-cancel"
                onClick={closeInfoModal}
            > Cancel </Button>
        </Modal.Actions>
    </Modal>
}
export default PlaybookInfoModal;